import 'normalize.css';
import '@src/static/fonts/fonts.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { applyThemeToDocument, applyThemeFavicon, getStoredTheme } from '@src/utils/themeStorage';
import { scheduleGoogleAnalytics, trackPageView } from '@src/utils/loadGoogleAnalytics';
import { bindLinkClickTracking } from '@src/utils/linkClickTracking';

const pinScrollTop = () => {
  if (typeof window === 'undefined' || window.location.hash) return;
  window.scrollTo(0, 0);
  window.lenis?.scrollTo(0, { immediate: true });
};

const redirectBlogToWritings = () => {
  if (typeof window === 'undefined') return false;

  const { pathname, search, hash } = window.location;
  if (!pathname.startsWith('/blog')) return false;

  const nextPath = pathname.replace(/^\/blog\/?/, '/writings/');
  window.location.replace(`${nextPath}${search}${hash}`);
  return true;
};

//One with 99% Config
export const onClientEntry = async () => {
  if (typeof window !== 'undefined') {
    if (redirectBlogToWritings()) return;

    applyThemeToDocument(getStoredTheme());
    // Arm the hero entrance animation. In production the inline head script
    // (html.js) already adds this before paint; html.js is not used in
    // `gatsby develop`, so this client hook ensures the animation also plays
    // in dev. classList.add is idempotent, so the duplicate in prod is a no-op.
    document.documentElement.classList.add('hero-armed');
    window.requestAnimationFrame(() => applyThemeFavicon(getStoredTheme()));
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    pinScrollTop();

    if (process.env.NODE_ENV === 'production') {
      scheduleGoogleAnalytics();
      bindLinkClickTracking();
    }
  }
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined' && !location.hash) {
    window.scrollTo(0, 0);
    window.lenis?.scrollTo(0, { immediate: true });
    window.requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      window.lenis?.scrollTo(0, { immediate: true });
    });
  }

  applyThemeFavicon(getStoredTheme());

  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  const pagePath = location?.pathname + location.search + location.hash;
  trackPageView(pagePath);
};

export const onServiceWorkerUpdateReady = () => {
  window.location.reload();
};

// Polyfill TextEncoder and TextDecoder for the browser
if (typeof window !== 'undefined') {
  if (typeof window.TextEncoder === 'undefined') {
    window.TextEncoder = class TextEncoder {
      encode(str) {
        const arr = new Uint8Array(str.length);
        for (let i = 0; i < str.length; i++) {
          arr[i] = str.charCodeAt(i);
        }
        return arr;
      }
    };
  }

  if (typeof window.TextDecoder === 'undefined') {
    window.TextDecoder = class TextDecoder {
      decode(arr) {
        return String.fromCharCode.apply(null, arr);
      }
    };
  }
}
